import { render, staticRenderFns } from "./TextimagesectionBlock.vue?vue&type=template&id=d383b6f8&scoped=true"
import script from "./TextimagesectionBlock.vue?vue&type=script&lang=js"
export * from "./TextimagesectionBlock.vue?vue&type=script&lang=js"
import style0 from "./TextimagesectionBlock.vue?vue&type=style&index=0&id=d383b6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d383b6f8",
  null
  
)

export default component.exports